import React from 'react'
import { RuleSet } from 'styled-components'
import RenderIf from 'src/components/RenderIf'
import { IconButton } from 'src/pages/Rop03JoinFormPage/components/Button/IconButton'
import {
  DefaultButton,
  PrimaryButton,
  SecondaryButton,
} from 'src/pages/Rop03JoinFormPage/components/Button/styled'
import { Icon } from 'src/assets/svg/Icon'

interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  name?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  renderIf?: boolean
  disabled?: boolean
  children?: React.ReactNode
  backgroundColor?: string
  isLoading?: boolean
  $style?: RuleSet<object>
  // style?: React.CSSProperties
  icon?: React.ReactNode
  iconSrc?: string
  iconAlt?: string
  iconPosition?: 'left' | 'right'
  iconSize?: number
  iconGap?: number
  type?: 'button'
}

const OtpCertRequestButton = (props: ButtonProps) => {
  const {
    name = '인증번호 발송',
    renderIf = true,
    isLoading = false,
    disabled,
    ...remainProps
  } = props
  return (
    <RenderIf when={renderIf}>
      <IconButton
        {...remainProps}
        className="btn_send_sms"
        name={name}
        disabled={disabled || isLoading}
        isLoading={isLoading}
      />
    </RenderIf>
  )
}

const ReTryOtpCertRequestButton = (props: ButtonProps) => {
  const { name = '재발송', renderIf = true, isLoading = false, disabled, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <PrimaryButton
        {...remainProps}
        className="btn_resend_sms"
        disabled={disabled || isLoading}
        $isLoading={isLoading}
      >
        {isLoading && <Icon.Spin />}
        {isLoading ? '' : name}
      </PrimaryButton>
    </RenderIf>
  )
}

const JoinSubmitButton = (props: ButtonProps) => {
  const {
    name = '휴대폰쿠폰지갑 유료부가서비스가입',
    isLoading = false,
    disabled,
    renderIf = true,
    children,
    icon,
    iconSrc,
    iconAlt = '',
    iconPosition = 'right',
    iconSize = 24,
    iconGap = 8,
    ...remainProps
  } = props
  return (
    <RenderIf when={renderIf}>
      <IconButton
        {...remainProps}
        className="btn_signup"
        disabled={disabled || isLoading}
        isLoading={isLoading}
        icon={icon}
        iconSrc={iconSrc}
        iconAlt={iconAlt}
        iconPosition={iconPosition}
        iconSize={iconSize}
        iconGap={iconGap}
      >
        {isLoading ? <Icon.Spin /> : (children ?? name)}
      </IconButton>
    </RenderIf>
  )
}

const MvnoTermsSubmitButton = (props: ButtonProps) => {
  const {
    name = '동의 및 인증번호 받기',
    isLoading = false,
    disabled,
    renderIf = true,
    ...remainProps
  } = props
  return (
    <RenderIf when={renderIf}>
      <PrimaryButton {...remainProps} disabled={disabled || isLoading} $isLoading={isLoading}>
        {isLoading && <Icon.Spin />}
        {isLoading ? '' : name || '동의 및 인증번호 받기'}
      </PrimaryButton>
    </RenderIf>
  )
}

const CancelResetButton = (props: ButtonProps) => {
  const { name = '취소', renderIf = true, isLoading = false, disabled, ...remainProps } = props
  return (
    <RenderIf when={renderIf}>
      <DefaultButton
        {...remainProps}
        className="btn_cancel"
        disabled={disabled || isLoading}
        $isLoading={isLoading}
      >
        {isLoading && <Icon.Spin />}
        {isLoading ? '' : name}
      </DefaultButton>
    </RenderIf>
  )
}
export const Button = {
  Default: DefaultButton,
  Primary: PrimaryButton,
  Secondary: SecondaryButton,
  JoinSubmit: JoinSubmitButton,
  OtpCertRequest: OtpCertRequestButton,
  RetryOtpCertRequest: ReTryOtpCertRequestButton,
  CancelReset: CancelResetButton,
  MvnoTermsSubmit: MvnoTermsSubmitButton,
}
